export default "__VITE_ASSET__B8FPsi7i__"